import { LOCALES } from './common';

export const COUNTRIES = [
  { nameEn: 'Afghanistan', nameRu: 'Афганистан', code: '+93', iso: 'AF' },
  { nameEn: 'Albania', nameRu: 'Албания', code: '+355', iso: 'AL' },
  { nameEn: 'Algeria', nameRu: 'Алжир', code: '+213', iso: 'DZ' },
  {
    nameEn: 'American Samoa',
    nameRu: 'Американское Самоа',
    code: '+1-684',
    iso: 'AS',
  },
  { nameEn: 'Andorra', nameRu: 'Андорра', code: '+376', iso: 'AD' },
  { nameEn: 'Angola', nameRu: 'Ангола', code: '+244', iso: 'AO' },
  { nameEn: 'Anguilla', nameRu: 'Ангилья', code: '+1-264', iso: 'AI' },
  { nameEn: 'Antarctica', nameRu: 'Антарктида', code: '+672', iso: 'AQ' },
  {
    nameEn: 'Antigua and Barbuda',
    nameRu: 'Антигуа и Барбуда',
    code: '+1-268',
    iso: 'AG',
  },
  { nameEn: 'Argentina', nameRu: 'Аргентина', code: '+54', iso: 'AR' },
  { nameEn: 'Armenia', nameRu: 'Армения', code: '+374', iso: 'AM' },
  { nameEn: 'Aruba', nameRu: 'Аруба', code: '+297', iso: 'AW' },
  { nameEn: 'Australia', nameRu: 'Австралия', code: '+61', iso: 'AU' },
  { nameEn: 'Austria', nameRu: 'Австрия', code: '+43', iso: 'AT' },
  { nameEn: 'Azerbaijan', nameRu: 'Азербайджан', code: '+994', iso: 'AZ' },
  { nameEn: 'Bahamas', nameRu: 'Багамы', code: '+1-242', iso: 'BS' },
  { nameEn: 'Bahrain', nameRu: 'Бахрейн', code: '+973', iso: 'BH' },
  { nameEn: 'Bangladesh', nameRu: 'Бангладеш', code: '+880', iso: 'BD' },
  { nameEn: 'Barbados', nameRu: 'Барбадос', code: '+1-246', iso: 'BB' },
  { nameEn: 'Belarus', nameRu: 'Беларусь', code: '+375', iso: 'BY' },
  { nameEn: 'Belgium', nameRu: 'Бельгия', code: '+32', iso: 'BE' },
  { nameEn: 'Belize', nameRu: 'Белиз', code: '+501', iso: 'BZ' },
  { nameEn: 'Benin', nameRu: 'Бенин', code: '+229', iso: 'BJ' },
  { nameEn: 'Bermuda', nameRu: 'Бермуды', code: '+1-441', iso: 'BM' },
  { nameEn: 'Bhutan', nameRu: 'Бутан', code: '+975', iso: 'BT' },
  { nameEn: 'Bolivia', nameRu: 'Боливия', code: '+591', iso: 'BO' },
  {
    nameEn: 'Bosnia and Herzegovina',
    nameRu: 'Босния и Герцеговина',
    code: '+387',
    iso: 'BA',
  },
  { nameEn: 'Botswana', nameRu: 'Ботсвана', code: '+267', iso: 'BW' },
  { nameEn: 'Brazil', nameRu: 'Бразилия', code: '+55', iso: 'BR' },
  { nameEn: 'Brunei', nameRu: 'Бруней', code: '+673', iso: 'BN' },
  { nameEn: 'Bulgaria', nameRu: 'Болгария', code: '+359', iso: 'BG' },
  { nameEn: 'Burkina Faso', nameRu: 'Буркина-Фасо', code: '+226', iso: 'BF' },
  { nameEn: 'Burundi', nameRu: 'Бурунди', code: '+257', iso: 'BI' },
  { nameEn: 'Cambodia', nameRu: 'Камбоджа', code: '+855', iso: 'KH' },
  { nameEn: 'Cameroon', nameRu: 'Камерун', code: '+237', iso: 'CM' },
  { nameEn: 'Canada', nameRu: 'Канада', code: '+1', iso: 'CA' },
  { nameEn: 'Cape Verde', nameRu: 'Кабо-Верде', code: '+238', iso: 'CV' },
  {
    nameEn: 'Cayman Islands',
    nameRu: 'Острова Кайман',
    code: '+1-345',
    iso: 'KY',
  },
  {
    nameEn: 'Central African Republic',
    nameRu: 'Центрально-Африканская Республика',
    code: '+236',
    iso: 'CF',
  },
  { nameEn: 'Chad', nameRu: 'Чад', code: '+235', iso: 'TD' },
  { nameEn: 'Chile', nameRu: 'Чили', code: '+56', iso: 'CL' },
  { nameEn: 'China', nameRu: 'Китай', code: '+86', iso: 'CN' },
  {
    nameEn: 'Christmas Island',
    nameRu: 'Остров Рождества',
    code: '+61',
    iso: 'CX',
  },
  {
    nameEn: 'Cocos Islands',
    nameRu: 'Кокос (Килинг) острова',
    code: '+61',
    iso: 'CC',
  },
  { nameEn: 'Colombia', nameRu: 'Колумбия', code: '+57', iso: 'CO' },
  { nameEn: 'Comoros', nameRu: 'Коморы', code: '+269', iso: 'KM' },
  { nameEn: 'Cook Islands', nameRu: 'Острова Кука', code: '+682', iso: 'CK' },
  { nameEn: 'Costa Rica', nameRu: 'Коста-Рика', code: '+506', iso: 'CR' },
  { nameEn: 'Croatia', nameRu: 'Хорватия', code: '+385', iso: 'HR' },
  { nameEn: 'Cuba', nameRu: 'Куба', code: '+53', iso: 'CU' },
  { nameEn: 'Curacao', nameRu: 'Кюрасао', code: '+599', iso: 'CW' },
  { nameEn: 'Cyprus', nameRu: 'Кипр', code: '+357', iso: 'CY' },
  { nameEn: 'Czech Republic', nameRu: 'Чехия', code: '+420', iso: 'CZ' },
  {
    nameEn: 'Democratic Republic of the Congo',
    nameRu: 'Демократическая Республика Конго',
    code: '+243',
    iso: 'CD',
  },
  { nameEn: 'Denmark', nameRu: 'Дания', code: '+45', iso: 'DK' },
  { nameEn: 'Djibouti', nameRu: 'Джибути', code: '+253', iso: 'DJ' },
  { nameEn: 'Dominica', nameRu: 'Доминика', code: '+1-767', iso: 'DM' },
  {
    nameEn: 'Dominican Republic',
    nameRu: 'Доминиканская Республика',
    code: '+1-809',
    iso: 'DO',
  },
  { nameEn: 'East Timor', nameRu: 'Восточный Тимор', code: '+670', iso: 'TL' },
  { nameEn: 'Ecuador', nameRu: 'Эквадор', code: '+593', iso: 'EC' },
  { nameEn: 'Egypt', nameRu: 'Египет', code: '+20', iso: 'EG' },
  { nameEn: 'El Salvador', nameRu: 'Сальвадор', code: '+503', iso: 'SV' },
  {
    nameEn: 'Equatorial Guinea',
    nameRu: 'Экваториальная Гвинея',
    code: '+240',
    iso: 'GQ',
  },
  { nameEn: 'Eritrea', nameRu: 'Эритрея', code: '+291', iso: 'ER' },
  { nameEn: 'Estonia', nameRu: 'Эстония', code: '+372', iso: 'EE' },
  { nameEn: 'Ethiopia', nameRu: 'Эфиопия', code: '+251', iso: 'ET' },
  {
    nameEn: 'Falkland Islands',
    nameRu: 'Фолклендские острова',
    code: '+500',
    iso: 'FK',
  },
  {
    nameEn: 'Faroe Islands',
    nameRu: 'Фарерские острова',
    code: '+298',
    iso: 'FO',
  },
  { nameEn: 'Fiji', nameRu: 'Фиджи', code: '+679', iso: 'FJ' },
  { nameEn: 'Finland', nameRu: 'Финляндия', code: '+358', iso: 'FI' },
  { nameEn: 'France', nameRu: 'Франция', code: '+33', iso: 'FR' },
  {
    nameEn: 'French Polynesia',
    nameRu: 'Французская Полинезия',
    code: '+689',
    iso: 'PF',
  },
  { nameEn: 'Gabon', nameRu: 'Габон', code: '+241', iso: 'GA' },
  { nameEn: 'Gambia', nameRu: 'Гамбия', code: '+220', iso: 'GM' },
  { nameEn: 'Georgia', nameRu: 'Грузия', code: '+995', iso: 'GE' },
  { nameEn: 'Germany', nameRu: 'Германия', code: '+49', iso: 'DE' },
  { nameEn: 'Ghana', nameRu: 'Гана', code: '+233', iso: 'GH' },
  { nameEn: 'Gibraltar', nameRu: 'Гибралтар', code: '+350', iso: 'GI' },
  { nameEn: 'Greece', nameRu: 'Греция', code: '+30', iso: 'GR' },
  { nameEn: 'Greenland', nameRu: 'Гренландия', code: '+299', iso: 'GL' },
  { nameEn: 'Grenada', nameRu: 'Гренада', code: '+1-473', iso: 'GD' },
  { nameEn: 'Guam', nameRu: 'Гуам', code: '+1-671', iso: 'GU' },
  { nameEn: 'Guatemala', nameRu: 'Гватемала', code: '+502', iso: 'GT' },
  { nameEn: 'Guernsey', nameRu: 'Гернси', code: '+44-1481', iso: 'GG' },
  { nameEn: 'Guinea', nameRu: 'Гвинея', code: '+224', iso: 'GN' },
  { nameEn: 'Guinea-Bissau', nameRu: 'Гвинея-Бисау', code: '+245', iso: 'GW' },
  { nameEn: 'Guyana', nameRu: 'Гайана', code: '+592', iso: 'GY' },
  { nameEn: 'Haiti', nameRu: 'Гаити', code: '+509', iso: 'HT' },
  { nameEn: 'Honduras', nameRu: 'Гондурас', code: '+504', iso: 'HN' },
  { nameEn: 'Hong Kong', nameRu: 'Гонконг', code: '+852', iso: 'HK' },
  { nameEn: 'Hungary', nameRu: 'Венгрия', code: '+36', iso: 'HU' },
  { nameEn: 'Iceland', nameRu: 'Исландия', code: '+354', iso: 'IS' },
  { nameEn: 'India', nameRu: 'Индия', code: '+91', iso: 'IN' },
  { nameEn: 'Indonesia', nameRu: 'Индонезия', code: '+62', iso: 'ID' },
  { nameEn: 'Iran', nameRu: 'Иран', code: '+98', iso: 'IR' },
  { nameEn: 'Iraq', nameRu: 'Ирак', code: '+964', iso: 'IQ' },
  { nameEn: 'Ireland', nameRu: 'Ирландия', code: '+353', iso: 'IE' },
  { nameEn: 'Isle of Man', nameRu: 'Остров Мэн', code: '+44-1624', iso: 'IM' },
  { nameEn: 'Israel', nameRu: 'Израиль', code: '+972', iso: 'IL' },
  { nameEn: 'Italy', nameRu: 'Италия', code: '+39', iso: 'IT' },
  { nameEn: 'Ivory Coast', nameRu: "Кот-д'Ивуар", code: '+225', iso: 'CI' },
  { nameEn: 'Jamaica', nameRu: 'Ямайка', code: '+1-876', iso: 'JM' },
  { nameEn: 'Japan', nameRu: 'Япония', code: '+81', iso: 'JP' },
  { nameEn: 'Jersey', nameRu: 'Джерси', code: '+44-1534', iso: 'JE' },
  { nameEn: 'Jordan', nameRu: 'Иордания', code: '+962', iso: 'JO' },
  { nameEn: 'Kazakhstan', nameRu: 'Казахстан', code: '+7', iso: 'KZ' },
  { nameEn: 'Kenya', nameRu: 'Кения', code: '+254', iso: 'KE' },
  { nameEn: 'Kiribati', nameRu: 'Кирибати', code: '+686', iso: 'KI' },
  { nameEn: 'Kosovo', nameRu: 'Косово', code: '+383', iso: 'XK' },
  { nameEn: 'Kuwait', nameRu: 'Кувейт', code: '+965', iso: 'KW' },
  { nameEn: 'Kyrgyzstan', nameRu: 'Киргизия', code: '+996', iso: 'KG' },
  { nameEn: 'Laos', nameRu: 'Лаос', code: '+856', iso: 'LA' },
  { nameEn: 'Latvia', nameRu: 'Латвия', code: '+371', iso: 'LV' },
  { nameEn: 'Lebanon', nameRu: 'Ливан', code: '+961', iso: 'LB' },
  { nameEn: 'Lesotho', nameRu: 'Лесото', code: '+266', iso: 'LS' },
  { nameEn: 'Liberia', nameRu: 'Либерия', code: '+231', iso: 'LR' },
  { nameEn: 'Libya', nameRu: 'Ливия', code: '+218', iso: 'LY' },
  { nameEn: 'Liechtenstein', nameRu: 'Лихтенштейн', code: '+423', iso: 'LI' },
  { nameEn: 'Lithuania', nameRu: 'Литва', code: '+370', iso: 'LT' },
  { nameEn: 'Luxembourg', nameRu: 'Люксембург', code: '+352', iso: 'LU' },
  { nameEn: 'Macao', nameRu: 'Макао', code: '+853', iso: 'MO' },
  { nameEn: 'Macedonia', nameRu: 'Македония', code: '+389', iso: 'MK' },
  { nameEn: 'Madagascar', nameRu: 'Мадагаскар', code: '+261', iso: 'MG' },
  { nameEn: 'Malawi', nameRu: 'Малави', code: '+265', iso: 'MW' },
  { nameEn: 'Malaysia', nameRu: 'Малайзия', code: '+60', iso: 'MY' },
  { nameEn: 'Maldives', nameRu: 'Мальдивы', code: '+960', iso: 'MV' },
  { nameEn: 'Mali', nameRu: 'Мали', code: '+223', iso: 'ML' },
  { nameEn: 'Malta', nameRu: 'Мальта', code: '+356', iso: 'MT' },
  {
    nameEn: 'Marshall Islands',
    nameRu: 'Маршалловы Острова',
    code: '+692',
    iso: 'MH',
  },
  { nameEn: 'Mauritania', nameRu: 'Мавритания', code: '+222', iso: 'MR' },
  { nameEn: 'Mauritius', nameRu: 'Маврикий', code: '+230', iso: 'MU' },
  { nameEn: 'Mayotte', nameRu: 'Майотта', code: '+262', iso: 'YT' },
  { nameEn: 'Mexico', nameRu: 'Мексика', code: '+52', iso: 'MX' },
  { nameEn: 'Micronesia', nameRu: 'Микронезия', code: '+691', iso: 'FM' },
  { nameEn: 'Moldova', nameRu: 'Молдова', code: '+373', iso: 'MD' },
  { nameEn: 'Monaco', nameRu: 'Монако', code: '+377', iso: 'MC' },
  { nameEn: 'Mongolia', nameRu: 'Монголия', code: '+976', iso: 'MN' },
  { nameEn: 'Montenegro', nameRu: 'Черногория', code: '+382', iso: 'ME' },
  { nameEn: 'Montserrat', nameRu: 'Монтсеррат', code: '+1-664', iso: 'MS' },
  { nameEn: 'Morocco', nameRu: 'Марокко', code: '+212', iso: 'MA' },
  { nameEn: 'Mozambique', nameRu: 'Мозамбик', code: '+258', iso: 'MZ' },
  { nameEn: 'Myanmar', nameRu: 'Мьянма', code: '+95', iso: 'MM' },
  { nameEn: 'Namibia', nameRu: 'Намибия', code: '+264', iso: 'NA' },
  { nameEn: 'Nauru', nameRu: 'Науру', code: '+674', iso: 'NR' },
  { nameEn: 'Nepal', nameRu: 'Непал', code: '+977', iso: 'NP' },
  { nameEn: 'Netherlands', nameRu: 'Нидерланды', code: '+31', iso: 'NL' },
  {
    nameEn: 'New Caledonia',
    nameRu: 'Новая Каледония',
    code: '+687',
    iso: 'NC',
  },
  { nameEn: 'New Zealand', nameRu: 'Новая Зеландия', code: '+64', iso: 'NZ' },
  { nameEn: 'Nicaragua', nameRu: 'Никарагуа', code: '+505', iso: 'NI' },
  { nameEn: 'Niger', nameRu: 'Нигер', code: '+227', iso: 'NE' },
  { nameEn: 'Nigeria', nameRu: 'Нигерия', code: '+234', iso: 'NG' },
  { nameEn: 'Niue', nameRu: 'Ниуэ', code: '+683', iso: 'NU' },
  { nameEn: 'North Korea', nameRu: 'Северная Корея', code: '+850', iso: 'KP' },
  {
    nameEn: 'Northern Mariana Islands',
    nameRu: 'Северные Марианские острова',
    code: '+1-670',
    iso: 'MP',
  },
  { nameEn: 'Norway', nameRu: 'Норвегия', code: '+47', iso: 'NO' },
  { nameEn: 'Oman', nameRu: 'Оман', code: '+968', iso: 'OM' },
  { nameEn: 'Pakistan', nameRu: 'Пакистан', code: '+92', iso: 'PK' },
  { nameEn: 'Palau', nameRu: 'Палау', code: '+680', iso: 'PW' },
  { nameEn: 'Palestine', nameRu: 'Палестина', code: '+970', iso: 'PS' },
  { nameEn: 'Panama', nameRu: 'Панама', code: '+507', iso: 'PA' },
  {
    nameEn: 'Papua New Guinea',
    nameRu: 'Папуа-Новая Гвинея',
    code: '+675',
    iso: 'PG',
  },
  { nameEn: 'Paraguay', nameRu: 'Парагвай', code: '+595', iso: 'PY' },
  { nameEn: 'Peru', nameRu: 'Перу', code: '+51', iso: 'PE' },
  { nameEn: 'Philippines', nameRu: 'Филиппины', code: '+63', iso: 'PH' },
  { nameEn: 'Pitcairn', nameRu: 'Питкэрн', code: '+64', iso: 'PN' },
  { nameEn: 'Poland', nameRu: 'Польша', code: '+48', iso: 'PL' },
  { nameEn: 'Portugal', nameRu: 'Португалия', code: '+351', iso: 'PT' },
  {
    nameEn: 'Puerto Rico',
    nameRu: 'Пуэрто-Рико',
    code: '+1-787, 1-939',
    iso: 'PR',
  },
  { nameEn: 'Qatar', nameRu: 'Катар', code: '+974', iso: 'QA' },
  {
    nameEn: 'Republic of the Congo',
    nameRu: 'Республика Конго',
    code: '+242',
    iso: 'CG',
  },
  { nameEn: 'Reunion', nameRu: 'Реюньон', code: '+262', iso: 'RE' },
  { nameEn: 'Romania', nameRu: 'Румыния', code: '+40', iso: 'RO' },
  { nameEn: 'Russia', nameRu: 'Россия', code: '+7', iso: 'RU' },
  { nameEn: 'Rwanda', nameRu: 'Руанда', code: '+250', iso: 'RW' },
  {
    nameEn: 'Saint Barthelemy',
    nameRu: 'Сен-Бартельми',
    code: '+590',
    iso: 'BL',
  },
  { nameEn: 'Saint Helena', nameRu: 'Святая Елена', code: '+290', iso: 'SH' },
  {
    nameEn: 'Saint Kitts and Nevis',
    nameRu: 'Сент-Китс и Невис',
    code: '+1-869',
    iso: 'KN',
  },
  { nameEn: 'Saint Lucia', nameRu: 'Сент-Люсия', code: '+1-758', iso: 'LC' },
  { nameEn: 'Saint Martin', nameRu: 'Сен-Мартен', code: '+590', iso: 'MF' },
  {
    nameEn: 'Saint Pierre and Miquelon',
    nameRu: 'Сен-Пьер и Микелон',
    code: '+508',
    iso: 'PM',
  },
  {
    nameEn: 'Saint Vincent and the Grenadines',
    nameRu: 'Сент-Винсент и Гренадины',
    code: '+1-784',
    iso: 'VC',
  },
  { nameEn: 'Samoa', nameRu: 'Самоа', code: '+685', iso: 'WS' },
  { nameEn: 'San Marino', nameRu: 'Сан-Марино', code: '+378', iso: 'SM' },
  {
    nameEn: 'Sao Tome and Principe',
    nameRu: 'Сан-Томе и Принсипи',
    code: '+239',
    iso: 'ST',
  },
  {
    nameEn: 'Saudi Arabia',
    nameRu: 'Саудовская Аравия',
    code: '+966',
    iso: 'SA',
  },
  { nameEn: 'Senegal', nameRu: 'Сенегал', code: '+221', iso: 'SN' },
  { nameEn: 'Serbia', nameRu: 'Сербия', code: '+381', iso: 'RS' },
  {
    nameEn: 'Seychelles',
    nameRu: 'Сейшельские острова',
    code: '+248',
    iso: 'SC',
  },
  { nameEn: 'Sierra Leone', nameRu: 'Сьерра-Леоне', code: '+232', iso: 'SL' },
  { nameEn: 'Singapore', nameRu: 'Сингапур', code: '+65', iso: 'SG' },
  { nameEn: 'Sint Maarten', nameRu: 'Синт-Мартен', code: '+1-721', iso: 'SX' },
  { nameEn: 'Slovakia', nameRu: 'Словакия', code: '+421', iso: 'SK' },
  { nameEn: 'Slovenia', nameRu: 'Словения', code: '+386', iso: 'SI' },
  {
    nameEn: 'Solomon Islands',
    nameRu: 'Соломоновы острова',
    code: '+677',
    iso: 'SB',
  },
  { nameEn: 'Somalia', nameRu: 'Сомали', code: '+252', iso: 'SO' },
  { nameEn: 'South Africa', nameRu: 'Южная Африка', code: '+27', iso: 'ZA' },
  { nameEn: 'South Korea', nameRu: 'Южная Корея', code: '+82', iso: 'KR' },
  { nameEn: 'South Sudan', nameRu: 'Южный Судан', code: '+211', iso: 'SS' },
  { nameEn: 'Spain', nameRu: 'Испания', code: '+34', iso: 'ES' },
  { nameEn: 'Sri Lanka', nameRu: 'Шри-Ланка', code: '+94', iso: 'LK' },
  { nameEn: 'Sudan', nameRu: 'Судан', code: '+249', iso: 'SD' },
  { nameEn: 'Suriname', nameRu: 'Суринам', code: '+597', iso: 'SR' },
  {
    nameEn: 'Svalbard and Jan Mayen',
    nameRu: 'Свальбард и Ян Майен',
    code: '+47',
    iso: 'SJ',
  },
  { nameEn: 'Swaziland', nameRu: 'Свазиленд', code: '+268', iso: 'SZ' },
  { nameEn: 'Sweden', nameRu: 'Швеция', code: '+46', iso: 'SE' },
  { nameEn: 'Switzerland', nameRu: 'Швейцария', code: '+41', iso: 'CH' },
  { nameEn: 'Syria', nameRu: 'Сирия', code: '+963', iso: 'SY' },
  { nameEn: 'Taiwan', nameRu: 'Тайвань', code: '+886', iso: 'TW' },
  { nameEn: 'Tajikistan', nameRu: 'Таджикистан', code: '+992', iso: 'TJ' },
  { nameEn: 'Tanzania', nameRu: 'Танзания', code: '+255', iso: 'TZ' },
  { nameEn: 'Thailand', nameRu: 'Тайланд', code: '+66', iso: 'TH' },
  { nameEn: 'Togo', nameRu: 'Того', code: '+228', iso: 'TG' },
  { nameEn: 'Tokelau', nameRu: 'Токелау', code: '+690', iso: 'TK' },
  { nameEn: 'Tonga', nameRu: 'Тонга', code: '+676', iso: 'TO' },
  {
    nameEn: 'Trinidad and Tobago',
    nameRu: 'Тринидад и Тобаго',
    code: '+1-868',
    iso: 'TT',
  },
  { nameEn: 'Tunisia', nameRu: 'Тунис', code: '+216', iso: 'TN' },
  { nameEn: 'Turkey', nameRu: 'Турция', code: '+90', iso: 'TR' },
  { nameEn: 'Turkmenistan', nameRu: 'Туркменистан', code: '+993', iso: 'TM' },
  {
    nameEn: 'Turks and Caicos Islands',
    nameRu: 'Туркс и Кайкос',
    code: '+1-649',
    iso: 'TC',
  },
  { nameEn: 'Tuvalu', nameRu: 'Тувалу', code: '+688', iso: 'TV' },
  {
    nameEn: 'U.S. Virgin Islands',
    nameRu: 'Американские Виргинские острова',
    code: '+1-340',
    iso: 'VI',
  },
  { nameEn: 'Uganda', nameRu: 'Уганда', code: '+256', iso: 'UG' },
  { nameEn: 'Ukraine', nameRu: 'Украина', code: '+380', iso: 'UA' },
  {
    nameEn: 'United Arab Emirates',
    nameRu: 'Объединенные Арабские Эмираты',
    code: '+971',
    iso: 'AE',
  },
  {
    nameEn: 'United Kingdom',
    nameRu: 'Великобритания',
    code: '+44',
    iso: 'GB',
  },
  { nameEn: 'United States', nameRu: 'США', code: '+1', iso: 'US' },
  { nameEn: 'Uruguay', nameRu: 'Уругвай', code: '+598', iso: 'UY' },
  { nameEn: 'Uzbekistan', nameRu: 'Узбекистан', code: '+998', iso: 'UZ' },
  { nameEn: 'Vanuatu', nameRu: 'Вануату', code: '+678', iso: 'VU' },
  { nameEn: 'Vatican', nameRu: 'Ватикан', code: '+379', iso: 'VA' },
  { nameEn: 'Venezuela', nameRu: 'Венесуэла', code: '+58', iso: 'VE' },
  { nameEn: 'Vietnam', nameRu: 'Вьетнам', code: '+84', iso: 'VN' },
  {
    nameEn: 'Wallis and Futuna',
    nameRu: 'Уоллис и Футуна',
    code: '+681',
    iso: 'WF',
  },
  {
    nameEn: 'Western Sahara',
    nameRu: 'Западная Сахара',
    code: '+212',
    iso: 'EH',
  },
  { nameEn: 'Yemen', nameRu: 'Йемен', code: '+967', iso: 'YE' },
  { nameEn: 'Zambia', nameRu: 'Замбия', code: '+260', iso: 'ZM' },
  { nameEn: 'Zimbabwe', nameRu: 'Зимбабве', code: '+263', iso: 'ZW' },
];

export const getCountriesForPhoneInput = (
  locale: string,
  flagsImages: Record<string, string>,
) => {
  const firstCountries = [
    ...new Set([
      locale.toUpperCase(),
      ...Object.values(LOCALES).map((locale) => locale.toUpperCase()),
    ]),
  ];

  return COUNTRIES.map((country) => ({
    label: locale === LOCALES.ru ? country.nameRu : country.nameEn,
    code: country.code,
    flag: flagsImages[country.iso],
    value: country.iso,
  }))
    .sort((a, b) => {
      return a.label.localeCompare(b.label);
    })
    .sort((a, b) => {
      if (firstCountries.includes(a.value) && !firstCountries.includes(b.value))
        return -1;
      if (!firstCountries.includes(a.value) && firstCountries.includes(b.value))
        return 1;

      if (firstCountries.includes(a.value) && firstCountries.includes(b.value))
        return (
          firstCountries.indexOf(a.value) - firstCountries.indexOf(b.value)
        );

      return 0;
    });
};
